/* Zurevan · JS propio — vanilla, sin librerías. Un init por componente. */
(function () {
  'use strict';

  if (window.__mtBooted) return;
  window.__mtBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll (observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--mt-delay')) {
        var group = el.closest('[data-mt-stagger]');
        if (group) {
          var sibs = Array.prototype.slice.call(group.querySelectorAll('.mt-reveal'));
          el.style.setProperty('--mt-delay', (sibs.indexOf(el) * 0.09) + 's');
        }
      }
      io.observe(el);
    });
  }

  /* ---- Parallax suave en heros (solo transform) ---- */
  function initParallax() {
    var layers = document.querySelectorAll('[data-mt-parallax]');
    if (!layers.length || reduce) return;
    var ticking = false;
    function update() {
      layers.forEach(function (layer) {
        var host = layer.closest('section') || layer.parentElement;
        var rect = host.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var amount = parseFloat(layer.getAttribute('data-mt-parallax')) || 24;
        layer.style.transform = 'scale(1.06) translateY(' + (progress * amount).toFixed(2) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var raw = el.getAttribute('data-mt-count');
        /* Solo animamos valores tipo 123 / 99% / 1200+. El resto se deja tal cual. */
        if (!/^\d[\d.]*\s*[%+]?$/.test(String(raw).trim())) { el.textContent = raw; return; }
        var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
        var suffix = raw.replace(/[0-9.]/g, '');
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('es-ES') + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = raw;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Pasos: resalta el paso visible + barra de progreso ---- */
  function initPasos() {
    var wrap = document.querySelector('[data-mt-pasos]');
    if (!wrap) return;
    var pasos = Array.prototype.slice.call(wrap.querySelectorAll('.mt-paso'));
    var bar = wrap.querySelector('.mt-pasos__bar span');
    if (!pasos.length) return;
    if (!('IntersectionObserver' in window)) { pasos.forEach(function (p) { p.classList.add('is-active'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          pasos.forEach(function (p) { p.classList.remove('is-active'); });
          e.target.classList.add('is-active');
          var idx = pasos.indexOf(e.target) + 1;
          if (bar) bar.style.width = Math.round((idx / pasos.length) * 100) + '%';
        }
      });
    }, { threshold: 0.6 });
    pasos.forEach(function (p) { io.observe(p); });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var g = document.querySelector('[data-mt-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-mt-gallery-main] img');
    var thumbs = g.querySelectorAll('.mt-pdp__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        var alt = t.getAttribute('data-alt') || '';
        if (full) { main.src = full; main.alt = alt; }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Variantes de producto ---- */
  function initVariants() {
    var wrap = document.querySelector('[data-mt-product-form]');
    var form = wrap ? wrap.querySelector('form') : null;
    if (!form) return;
    var dataEl = document.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-mt-price]');
    var compareEl = document.querySelector('[data-mt-compare]');
    var addBtn = form.querySelector('[data-mt-add]');
    var selects = form.querySelectorAll('[data-mt-option]');
    if (!selects.length) return;

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) {
        var checked = s.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-label-add'); }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = addBtn.getAttribute('data-label-soldout'); }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function boot() {
    initReveal();
    initParallax();
    initCountUp();
    initPasos();
    initGallery();
    initVariants();

    /* Failsafe: si por lo que sea el observer no dispara, nada se queda invisible.
       Revelamos lo que ya está en pantalla al cargar y, pasados unos segundos,
       cualquier cosa que siguiera oculta. */
    requestAnimationFrame(function () {
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) && r.bottom > 0) el.classList.add('mt-visible');
      });
    });
    setTimeout(function () {
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        el.classList.add('mt-visible');
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
